import { required, useTranslate } from 'react-admin'
import { Typography, styled, Paper } from '@mui/material'

import get from 'lodash/get'
import { COMMON_FIELDS, NEWS_FIELDS } from '../../../providers/localization/constant'
import { ImageField } from '../../fields'
import { PromotionBannerImageInputsProps } from '../../../resources/promotion-banners/type'
import { ImageBannerInput } from '../../inputs/ImageBannerInput'

const PaperStyled = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'center',
  color: theme.palette.text.secondary,
  minHeight: 200,
  maxHeight: 400,
  width: '100%',
  lineHeight: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  marginBottom: theme.spacing(4),
  '& .RaImageField-image': {
    verticalAlign: 'middle',
  },
}))

const ImagePreviewField = styled(ImageField)(() => ({
  '& .RaImageField-image': {
    margin: 0,
    width: '100%',
    height: '400px',
    objectFit: 'cover',
  },
}))

export const PromotionBannerImageInputs: React.FC<PromotionBannerImageInputsProps> = ({
  isApproved = false,
  isPublished = false,
  record,
}) => {
  const translate = useTranslate()
  return isApproved || isPublished ? (
    <PaperStyled variant='outlined'>
      {get(record, 'image.full_path') ? (
        <ImagePreviewField source='image.full_path' />
      ) : (
        <Typography variant='caption' sx={{ color: 'error.main' }}>
          {translate(`${NEWS_FIELDS}.no_image`)}
        </Typography>
      )}
    </PaperStyled>
  ) : (
    <ImageBannerInput
      source='image'
      label={`${COMMON_FIELDS}.image.label`}
      fallbackSource='full_path'
      accept='image/*'
      validate={[required()]}
      fullWidth
    />
  )
}
